<template>
  <div class='content' :class="visible ? 'content--visible' : ''">
      <h2>THE PRICE PATCHWORK</h2>
      <p>
         <strong>Sydney’s rental cost by neighbourhood.</strong>
      </p>
      <p>
        Mapping out the average two bedroom rental cost by postcode illuminates a city of two halves: the coastal North & East (where average rent sits above $600 per week almost everywhere); and the West & South (mostly sitting between the $300-$500 range).
      </p>
      <p>
        Within the major regions of Sydney, price disparities are common between neighbouring areas.
      </p>
      <p>
        What could be affecting this?
      </p>
      <p>
        In the case of areas like Chatswood, access to quality retail and public transport options are obvious drivers. In other areas, those drivers are not immediately obvious.
      </p>
      <p>
        However, the coastal and harbour driver is highly visible, with postcodes that are adjacent to major bodies of water often commanding a premium.
      </p>
      <multiselect 
        class="postcode__selector"
        :value="selectedPostcode" 
        :options="data" 
        track-by="postcode"
        label="label"
        @input="update_selected_postcode"
      ></multiselect>
  </div>
</template>

<script>
import tooltip_mixin from '@/assets/tooltip_mixin'
export default {
  props: {
    visible: {
        default: () => false
    }
  },
  mixins: [ tooltip_mixin ]
}
</script>

<style scoped>

.postcode__selector {
  width: 80%;
}

</style>
